// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Editable from 'components/Editable/Editable'
import Link from 'components/Link/Link'
import { get, loop, jsonEqual } from 'utilities/objects'

class Attachments extends React.Component {
	// renderItems = () => {
	// 	const { data } = this.props

	// 	if ( ! data.items ) {
	// 		return null
	// 	}

	// 	console.log( data.items, 'data.items' );

	// 	return data.items.map( ( item, i ) => {
	// 		return (
	// 			<div className="-item" key={ i }>
	// 				<div className="-title">{ item.title }</div>
	// 			</div>
	// 		)
	// 	} )
	// }

	renderItem = ( key, item ) => {
		if ( ! item.file || ! item.file.url ) {
			return null
		}

		if ( item.file.url.indexOf( '//' ) > -1 ) {
			return (
				<a href={ item.file.url } className="-item" key={ key } target="_blank" rel="noopener">
					<div className="-inner">
						<p dangerouslySetInnerHTML={ { __html: item.title } } />
					</div>
				</a>
			)
		}

		return (
			<Link to={ item.file.url } className="-item" key={ key }>
				<div className="-inner">
					<p dangerouslySetInnerHTML={ { __html: item.title } } />
				</div>
			</Link>
		)
	}

	render() {
		const { contentId, sectionId, data, isProtected, page, userCanEditPage, userIsLoggedIn } = this.props
		const markup = loop( data.items, this.renderItem )

		if ( ! markup && ! userCanEditPage && ! isProtected ) {
			return null
		}

		return (
			<div className="section-attachments">
				<div className="-inner">
					<div className="-content">
						<div className="-title">
							<Editable
								element="h2"
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="heading"
								content={ data.heading }
							/>
						</div>

						{ ( isProtected && ! userIsLoggedIn ) &&
							<p><a href={ `/signin?redirect_to=${page.url}` } className="open-normally">Sign in</a> for access to assessment documents.</p>
						}

						{ markup &&
							<Editable
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="items"
								element="div"
								className="-items"
								contentData={ data.items }
							>
								{ markup }
							</Editable>
						|| userCanEditPage &&
							<div className="on-editor-open edit-set-custom-block">
								<Editable
									id={ contentId }
									sectionId={ sectionId }
									sectionType={ data.type }
									sectionDataId="items"
									element="div"
									className="-items"
								/>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		userCanEditPage: siteData.current_user_can_edit_pages,
		userIsLoggedIn: state.site.userIsLoggedIn
	}
}

export default connect( mapStateToProps )( Attachments )



// WEBPACK FOOTER //
// ./components/PageSections/Attachments.jsx